import { z } from 'zod';
import { catalogueDocumentSchema } from './document';

/** The catalogue's collection path (QZ-D107). */
export const DOCUMENTS_PATH = '/documents';

/**
 * The body returned by `GET /documents` (QZ-D107): every catalogued document, ordered by
 * `compareSectionNames` on `document`, each one's `sections` ordered by `sortSections`. The
 * schema itself does not sort or check the order.
 */
export const listDocumentsResponseSchema = z
  .object({ documents: z.array(catalogueDocumentSchema) })
  .strip();
export type ListDocumentsResponse = z.infer<typeof listDocumentsResponseSchema>;
